import React from 'react';
import { merge, slice, ifElse, gt, always, identity, cond, lt, T } from 'ramda';
import { IconButton, FontIcon, FlatButton } from 'material-ui';
const activeColor = 'rgba(0, 0, 0, 0.64)';
const Pagination = ({ currentPage, totalPages, goToPage, noOfPagesToShow, style }) => {
  const pages = new Array(totalPages).fill(1).reduce((result, _, index) => {
    result.push(index + 1);
    return result;
  }, []);
  const start = cond([
    [gt(0), always(0)],
    [lt(totalPages - noOfPagesToShow), always(totalPages - noOfPagesToShow)],
    [T, identity],
  ])(currentPage - ((noOfPagesToShow + 1) / 2));
  return (
    <div style={merge({ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }, style)}>
      <IconButton onTouchTap={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
        <FontIcon className="tc-icon-chevron-left" color={currentPage === 1 ? '' : activeColor} />
      </IconButton>
      {
        slice(start < 0 ? 0 : start, start + noOfPagesToShow, pages).map((pageNo) => (
          <FlatButton
            onTouchTap={() => goToPage(pageNo)}
            key={pageNo}
            label={pageNo}
            secondary={pageNo === currentPage}
          />
        ))
      }
      <IconButton onTouchTap={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
        <FontIcon className="tc-icon-chevron-right" color={currentPage === totalPages ? '' : activeColor} />
      </IconButton>
    </div>
  );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/pagination/pagination.jsx